import { Component, Input, Output, SimpleChanges, SimpleChange, EventEmitter, OnChanges, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { AbstractFormComponent } from '../../../../core/abstract-form-component';
import { SettingsHttpService } from '../../../../services/settings/settings.http.service';
import { StorageUtil } from '../../../../utils/storage.util';
import { SettingsHttpUtil } from '../settings.util';
import { AuthUtil } from '../../../../utils/auth.utils';
import { BehaviorSubject } from 'rxjs';

@Component({
  moduleId: module.id,
  selector: 'bft-email-settings',
  templateUrl: 'email.settings.component.html'
})
export class EmailSettingsComponent extends AbstractFormComponent implements OnChanges {

  _required: boolean;

  @Input() email;
  @Input() display;
  @Input() set required(value: boolean) {
    this._required = value;
    // TODO костыль, для инициализации формы, которая инициализируется в OnInit (подумать как переделать)
    setTimeout(() => {
      if (value) {
        this.form.get('email').setValidators([Validators.required]);
        this.form.get('email').updateValueAndValidity();
      } else {
        this.form.get('email').clearValidators();
        this.form.get('email').updateValueAndValidity();
      }
    });
  }
  @Output() emailChange: EventEmitter<string> = new EventEmitter<string>();

  changeModeStatus: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private settingsHttpService: SettingsHttpService,
    private authUtil: AuthUtil
  ) {
    super();
  }

  buildForm(): FormGroup {
    return this.formBuilder.group({
      email: [this.email, [Validators.required]],
    });
  }

  getValidationMessages(): {} {
    return {
      email: {
        'required': 'Обязательное поле'
      }
    };
  }

  submit() {
   /* if (this.email === this.form.value.email) {
      this.changeModeStatus = false;
      return;
    }*/

    const data = {
      securityToken: StorageUtil.getToken(),
      emailVal: this.form.value.email,
    };

    const requestParams = SettingsHttpUtil.prepareParamsSettings(data);
    this.settingsHttpService.setSettings(requestParams).subscribe(
      success => {
        if (success) {
          this.changeModeStatus = false;
          this.email = this.form.value.email;

          this.authUtil.checkErrorResponse(success.json());
        }
      },
      error => {
      },
      () => {
      });
  }

  inputEmail({value}) {
    this.email = value;
    this.emailChange.emit(this.email);
  }

  ngOnChanges(changes: SimpleChanges) {
    const display: SimpleChange = changes.display;
    if (display && display.currentValue) {
      this.changeModeStatus = false;
      this.form.setValue({email: this.email});
    }
  }

  toggleChangeStatus($event) {
    $event.preventDefault();

    this.changeModeStatus = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/settings/email/email.settings.component.ts